import type { AssignmentBuilderSchemaInput } from '@repo/schemas/assignment/assignmentBuilder';

import { createIdbStore } from '@/lib/idb-store';

export interface AssignmentBuilderDraftRecord {
  values: Partial<AssignmentBuilderSchemaInput>;
  attachments: File[];
  updatedAt: number;
}

export const assignmentBuilderDraftStore = createIdbStore<AssignmentBuilderDraftRecord>('assignment-builder-drafts', 'drafts');
